import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import ConfirmationDialog from '../components/ConfirmationDialog';
import * as usersApi from '../api/users';
import * as authService from '../services/auth';

/**
 * Opens the account-deletion confirmation flow used by both the Profile form
 * ("Leave Food Rescue" / "Delete Account" button) and the native account menu.
 *
 * Step 1: type-"DELETE" confirmation. Step 2: reason picker. On confirm it calls
 * DELETE /me and logs the user out.
 */
export const openDeleteAccountDialog = () => {
  confirmAlert({
    title: 'Delete your account?',
    message: `This permanently deletes your Food Rescue US account and personal information, and
      removes you from any rescues you've claimed. This cannot be undone — you would need to
      create a new account to participate in future rescues. To confirm, type "DELETE" into the
      field below and tap "Confirm".`,
    buttons: [
      {
        label: 'Cancel',
        color: 'primary',
      },
      {
        label: 'Confirm',
        color: 'primary',
        requireDeleteInput: true,
        onClick: async (deleteReason = null, additionNotes = null) => {
          // call api to wipe out user
          await usersApi.deleteMe({
            delete_main_reason: deleteReason,
            delete_reason: additionNotes,
          });

          // logout user, bye bye
          authService.logout();
        },
      },
    ],
    customUI: ({ title, message, onClose, buttons }) => (
      <ConfirmationDialog
        buttons={buttons}
        closeDialog={onClose}
        title={title}
        message={message}
        secondStep={{
          display: true,
          title: 'Before your account is deleted',
          message: "Please let us know why you're deleting your account by selecting one of the reasons below.",
          selectOptions: [
            {
              label: 'Location',
              value: 'LOCATION',
            },
            {
              label: 'Time',
              value: 'TIME',
            },
            {
              label: 'Transportation',
              value: 'TRANSPORTATION',
            },
            {
              label: 'Physically Unable',
              value: 'PHYSICALLY_UNABLE',
            },
            {
              label: 'Behavioral concerns',
              value: 'BEHAVIORAL_CONCERNS',
            },
            {
              label: 'Inactive/Unknown',
              value: 'INACTIVE_UNKNOWN',
            },
          ],
        }}
      />
    ),
  });
};
